import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getRoleSchema, getUiSchema } from './Schema';

export default class RoleEditor extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onUpdate(formData);
  };

  render() {
    const { fetching, role, roles, resources } = this.props;
    return (
      <div className="form-list-container">
        <Form
          schema={getRoleSchema({
            roles: roles.roles.map((r) => r.role),
            resources,
          })}
          uiSchema={getUiSchema(resources)}
          formData={role}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

RoleEditor.propTypes = {
  fetching: PropTypes.bool,
  role: PropTypes.object,
  roles: PropTypes.array,
  onUpdate: PropTypes.func,
  resources: PropTypes.object,
};
